import { useCallback, useRef } from "react";

/**
 * Hook to skip the next auto-reset in react-table.
 * Used to preserve state across data updates.
 * @returns {[boolean, Function]}
 */
export function useSkipper() {
  const shouldSkipRef = useRef(true);
  const shouldSkip = shouldSkipRef.current;

  const skip = useCallback(() => {
    shouldSkipRef.current = false;
  }, []);

  // After render, reset skip to true
   
  return [shouldSkip, skip];
}
